import React, {
  useEffect,
  useState,
} from "react";

import { useLocation } from "react-router-dom";

const Navdata = () => {
  const location = useLocation();

  const [openMenus, setOpenMenus] =
    useState({});

  const [iscurrentState, setIscurrentState] =
    useState("Dashboard");


  // =====================================================
  // ACTIVE ROUTE
  // =====================================================

  useEffect(() => {
    const pathname = location.pathname;

    if (pathname.startsWith("/leads")) {
      setIscurrentState("Leads");
    } else if (
      pathname.startsWith("/campaigns") ||
      pathname === "/lead-sources" ||
      pathname === "/analytics"
    ) {
      setIscurrentState("Marketing");
    } else if (
      pathname === "/whatsapp" ||
      pathname.startsWith("/conversations")
    ) {
      setIscurrentState("Communications");
    } else if (
      pathname.startsWith("/applications") ||
      pathname === "/admissions"
    ) {
      setIscurrentState("Admissions");
    } else if (
      pathname.startsWith("/integrations")
    ) {
      setIscurrentState("Integrations");
    } else if (
      pathname.startsWith("/settings")
    ) {
      setIscurrentState("Settings");
    } else if (
      pathname.startsWith("/profile")
    ) {
      setIscurrentState("Profile");
    } else {
      setIscurrentState("Dashboard");
    }
  }, [location.pathname]);


  // =====================================================
  // MENU TOGGLE
  // =====================================================

  const toggleMenu = (menu) => {
    setOpenMenus((previous) => ({
      ...previous,
      [menu]:
        !previous[menu],
    }));
  };


  // =====================================================
  // SIDEBAR MENU
  // =====================================================

  const menuItems = [

    // ---------------------------------------------------
    // MAIN
    // ---------------------------------------------------

    {
      label: "Menu",
      isHeader: true,
    },

    {
      label: "Dashboard",
      icon: "ri-dashboard-2-line",
      link: "/dashboard",
    },


    // ---------------------------------------------------
    // LEADS
    // ---------------------------------------------------

    {
      label: "Leads",
      isHeader: true,
    },

    {
      label: "All Leads",
      icon: "ri-user-search-line",
      link: "/leads",
    },

    {
      label: "New Leads",
      icon: "ri-user-add-line",
      link: "/leads/new",
    },

    {
      label: "Follow-ups",
      icon: "ri-time-line",
      link: "/leads/follow-ups",
    },

    {
      label: "Counselling",
      icon: "ri-chat-3-line",
      link: "/leads/counselling",
    },


    // ---------------------------------------------------
    // MARKETING
    // ---------------------------------------------------

    {
      label: "Marketing",
      isHeader: true,
    },

    {
      label: "Campaigns",
      icon: "ri-megaphone-line",
      link: "/campaigns",
    },

    {
      label: "Lead Sources",
      icon: "ri-share-forward-line",
      link: "/lead-sources",
    },

    {
      label: "Analytics",
      icon: "ri-bar-chart-box-line",
      link: "/analytics",
    },


    // ---------------------------------------------------
    // COMMUNICATIONS
    // ---------------------------------------------------

    {
      label: "Communications",
      isHeader: true,
    },

    {
      label: "WhatsApp",
      icon: "ri-whatsapp-line",
      link: "/whatsapp",
    },

    {
      label: "Conversations",
      icon: "ri-message-3-line",
      link: "/conversations",
    },


    // ---------------------------------------------------
    // ADMISSIONS
    // ---------------------------------------------------

    {
      label: "Admissions",
      isHeader: true,
    },

    {
      label: "Applications",
      icon: "ri-file-list-3-line",
      link: "/applications",
    },

    {
      label: "Admissions",
      icon: "ri-graduation-cap-line",
      link: "/admissions",
    },


    // ---------------------------------------------------
    // INTEGRATIONS
    // ---------------------------------------------------

    {
      label: "Integrations",
      isHeader: true,
    },

    {
      label: "Meta",
      icon: "ri-facebook-box-line",
      link: "/integrations/meta",
    },

    {
      label: "Google",
      icon: "ri-google-line",
      link: "/integrations/google",
    },

    {
      label: "YouTube",
      icon: "ri-youtube-line",
      link: "/integrations/youtube",
    },

    {
      label: "WhatsApp",
      icon: "ri-whatsapp-line",
      link: "/integrations/whatsapp",
    },


    // // ---------------------------------------------------
    // // SETTINGS
    // // ---------------------------------------------------

    // {
    //   label: "Settings",
    //   isHeader: true,
    // },

    // {
    //   label: "Organization",
    //   icon: "ri-building-line",
    //   link: "/settings/organization",
    // },

    // {
    //   label: "Users & Roles",
    //   icon: "ri-team-line",
    //   link: "/settings/users",
    // },

    // {
    //   label: "Lead Statuses",
    //   icon: "ri-list-settings-line",
    //   link: "/settings/statuses",
    // },

    // {
    //   label: "Public Lead Form",
    //   icon: "ri-global-line",
    //   link: "/settings/public-leads",
    // },

    // {
    //   label: "Audit Logs",
    //   icon: "ri-file-history-line",
    //   link: "/settings/audit-logs",
    // },


    // // ---------------------------------------------------
    // // PROFILE
    // // ---------------------------------------------------

    // {
    //   label: "Profile",
    //   icon: "ri-user-line",
    //   link: "/profile",
    // },
  ];


  // =====================================================
  // LEGACY SIDEBAR COMPATIBILITY
  // =====================================================

  function updateIconSidebar(e) {
    if (
      e &&
      e.target &&
      e.target.getAttribute("subitems")
    ) {
      const ul =
        document.getElementById(
          "two-column-menu"
        );

      if (!ul) return;

      const iconItems =
        ul.querySelectorAll(
          ".nav-icon.active"
        );

      [
        ...iconItems,
      ].forEach((item) => {
        item.classList.remove(
          "active"
        );

        const id =
          item.getAttribute(
            "subitems"
          );

        const submenu =
          document.getElementById(id);

        if (submenu) {
          submenu.classList.remove(
            "show"
          );
        }
      });
    }
  }


  return (
    <React.Fragment>
      {menuItems}
    </React.Fragment>
  );
};

export default Navdata;